/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WhiteListCarDto { 
    id?: number;
    employeeName?: string | null;
    phoneNumber?: string | null;
    vehicleRegistrationNo?: string | null;
    state_Province?: string | null;
    isActive?: boolean;
    locationId?: number;
    locationCode?: string | null;
}

